<template>
  <div class="basic-info">
    <div class="info-card">
      <div class="info-card-title">基础信息</div>
      <a-descriptions :column="3" bordered size="middle">
        <a-descriptions-item label="ClientId">
          <span class="mono-text">{{ detail.clientId || '--' }}</span>
        </a-descriptions-item>
        <a-descriptions-item label="Secret">
          <div class="secret-wrap">
            <span :class="{ 'mono-text': true, 'secret-mask': !secretVisible }">
              {{ secretVisible ? (detail.secret || '--') : '••••••••••••••••••••••••••••••' }}
            </span>
            <a-button size="small" type="link" icon="eye" @click="secretVisible = !secretVisible" />
            <a-button size="small" type="link" icon="copy" @click="copySecret" />
          </div>
        </a-descriptions-item>
        <a-descriptions-item label="客户端名称">{{ detail.clientName || '--' }}</a-descriptions-item>
        <a-descriptions-item label="客户端分类">
          <a-tag v-if="detail.clientCategory" color="orange">{{ getCategoryLabel(detail.clientCategory) }}</a-tag>
          <span v-else>--</span>
        </a-descriptions-item>
        <a-descriptions-item label="客户端类型">
          <a-tag v-if="detail.clientType" :color="getTypeColor(detail.clientType)"><a-icon :type="getTypeIcon(detail.clientType)" style="margin-right: 5px;" />{{ getTypeLabel(detail.clientType) }}</a-tag>
          <span v-else>--</span>
        </a-descriptions-item>
        <a-descriptions-item label="状态">
          <span v-if="detail.status == 'ENABLED'" class="status-enable">● 启用</span>
          <span v-else class="status-disable">● 停用</span>
        </a-descriptions-item>
        <a-descriptions-item label="描述" :span="3">
          {{ detail.description || '--' }}
        </a-descriptions-item>
      </a-descriptions>
    </div>

    <div class="info-card" style="margin-top: 16px;">
      <a-descriptions :column="3" bordered size="middle">
        <a-descriptions-item label="服务设备数">{{ formatNumber(detail.serviceDeviceCount) || 0 }}</a-descriptions-item>
        <a-descriptions-item label="接入设备型号数">{{ detail.accessTypeCount || 0 }}</a-descriptions-item>
        <a-descriptions-item label="创建人">{{ detail.creator || '--' }}</a-descriptions-item>
        <a-descriptions-item label="最后操作人">{{ detail.lastOperator || '--' }}</a-descriptions-item>
        <a-descriptions-item label="创建时间">{{ detail.createTime ? $moment(detail.createTime).format('YYYY-MM-DD HH:mm:ss') : '--' }}</a-descriptions-item>
        <a-descriptions-item label="更新时间">{{ detail.updateTime ? $moment(detail.updateTime).format('YYYY-MM-DD HH:mm:ss') : '--' }}</a-descriptions-item>
      </a-descriptions>
    </div>
  </div>
</template>

<script>
import { CLIENT_TYPES, CLIENT_CATEGORIES } from '../clientConstants.js'

export default {
  name: 'BasicInfo',
  props: {
    detail: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      secretVisible: false,
    }
  },
  methods: {
    /* 复制 Secret */
    copySecret() {
      const val = this.detail.secret
      if (!val) return
      if (navigator.clipboard) {
        navigator.clipboard.writeText(val).then(() => {
          this.$message.success('复制成功')
        }).catch(() => {
          this.$message.info('复制失败，请手动复制')
        })
      } else {
        this.$message.info('当前浏览器不支持自动复制')
      }
    },
    getTypeLabel(value) {
      const t = CLIENT_TYPES.find((i) => i.value === value)
      return t ? t.label : value
    },
    getTypeIcon(value) {
      const t = CLIENT_TYPES.find((i) => i.value === value)
      return t ? t.icon : 'user'
    },
    getTypeColor(value) {
      const t = CLIENT_TYPES.find((i) => i.value === value)
      return t ? t.color : 'blue'
    },
    getCategoryLabel(value) {
      const t = CLIENT_CATEGORIES.find((i) => i.value === value)
      return t ? t.label : value
    },
    formatNumber(val) {
      if (!val) return 0
      return Number(val).toLocaleString()
    },
  },
}
</script>

<style lang="less" scoped>
.info-card-title {
  font-size: 15px;
  font-weight: 600;
  color: #151515;
  margin-bottom: 12px;
  padding-left: 10px;
  border-left: 3px solid #1890ff;
}

.mono-text {
  font-family: Menlo, Monaco, Consolas, monospace;
}

.secret-mask {
  letter-spacing: 1px;
}

.secret-wrap {
  display: flex;
  align-items: center;
  gap: 4px;
}

.status-enable { color: #52c41a; }
.status-disable { color: #bfbfbf; }
</style>
